import React,{ useState,useEffect} from "react";
import "./sections.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {getBlogsRegal_api} from "../../../Services/apis";


const imageParamss = {
    slidesPerView: '2',
    spaceBetween: 50,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function BlogRegalSec({item}){

    const [color,setColor] = useState("#f5f5f5")
    const [blogs,set_blogs] = useState([])
    const history = useHistory();

    useEffect(()=>{
        getBlogs()
    },[])

    const getBlogs = async ()=>{
        try{
            const res=  await getBlogsRegal_api()
            set_blogs(res.data)
        }catch (e) {
            console.log(e)
        }
    }

    return(
        <div className="blog-off-section" style={{
            backgroundColor: color,
            margin: "10px 0",
            padding: 8,
        }}>
            {blogs && blogs.length>0? <SwiperId {...imageParamss}>
                {/*<div className="swiper-blog-container blog-regal-cardi" style={{backgroundColor:color}}>*/}
                {/*    <div className="swiper-card-body">*/}
                {/*        <span>{item.title?item.title:"مقالات"}</span>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {blogs.map(i=>{
                    return(
                        <div style={{width:100}}>
                            <div className="swiper-blog-container" onClick={()=>{
                                // let split = item.items[0].text.split("@")
                                history.push(`/blog/${i.uid}`)
                            }}>
                                <div className="swiper-card-body" >
                                    {/*<BasketAddRemove i={i}/>*/}
                                    <div>
                                        <img src={i.cover} alt=""/>
                                    </div>
                                </div>
                                <div className="price-section">
                                    {limitText(i.title,25)}
                                </div>
                                {/*{i && i.discount_percentage!==0?*/}
                                {/*    <div className="off">*/}
                                {/*        <span>{i.discount_percentage+" % "}</span>*/}
                                {/*    </div>:null*/}
                                {/*}*/}
                                <div className="info-section">
                                    <div className="name">{limitText(i.body,250)}</div>
                                    {/*<div className="weight">1500 گرمی میهن</div>*/}
                                </div>
                            </div>
                        </div>
                    )
                })}
                {/*<div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>*/}
                {/*    <div className="swiper-card-body">*/}
                {/*        <div className="swiper-more-card">*/}
                {/*            <span>مشاهده مقالات </span>*/}
                {/*            <span>بیشتر</span>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>*/}
                {/*    <div className="swiper-card-body">*/}
                {/*        <span></span>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </SwiperId>:null}
        </div>
    )
}

export default BlogRegalSec
